import { render } from "./empresa.vue?vue&type=template&id=5ef1b5bc"
import script from "./empresa.vue?vue&type=script&lang=js"
export * from "./empresa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__